import axios from "axios";

/**
 * Base URL for authentication server without trailing slash
 */
const BASE_SERVER = "https://demo-service.saliorel.cloud";
const Authentication = {
  /**
   * User actions
   */
  User: {
    /**
     * Attempt authorization via server using credentials
     */
    loginWithCredentials: credentials =>
      axios
        .post(
          `${BASE_SERVER}/users/login`,
          { ...credentials },
          { withCredentials: true }
        )
        .then(res => ({
          uid: res.data.uid
        })),

    /**
     * Gets the currently logged in user
     */
    currentUser: () =>
      axios
        .get(`${BASE_SERVER}/users/me`, { withCredentials: true })
        .then(res => res.data)
  }
};

export const UserType = {
  Administrator: "admin",
  Student: "student",
  Teacher: "teacher",
  Demo: "demo",
  Other: "other"
};

export default Authentication;



// WEBPACK FOOTER //
// ./src/api/Authentication.js